import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateDec = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("g", {
			id: `${__svgrId}-Date Icons`,
			children: /* @__PURE__ */ _jsx("g", {
				id: `${__svgrId}-Icon / Date / December`,
				children: /* @__PURE__ */ _jsxs("g", {
					id: `${__svgrId}-Icons`,
					children: [
						/* @__PURE__ */ _jsx("rect", {
							height: 24.9624,
							id: `${__svgrId}-Rectangle 61`,
							stroke: "white",
							strokeLinejoin: "round",
							strokeWidth: 2.5,
							style: { fill: "var(--sticker-pastel,#FFC98E)" },
							width: 22.4432,
							x: 4.6789,
							y: 3.9967
						}),
						/* @__PURE__ */ _jsx("rect", {
							height: 22.4624,
							id: `${__svgrId}-Rectangle 59`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: {
								fill: "var(--sticker-pastel,#FFC98E)",
								stroke: "var(--sticker-dark,#9A6528)"
							},
							width: 19.9432,
							x: 5.9289,
							y: 5.2468
						}),
						/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							height: 12.9712,
							id: `${__svgrId}-Rectangle 60`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#9A6528)" },
							width: 19.9432,
							x: 5.9311,
							y: 14.7382
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M8.6188 12.8961 L8.6189 7.2962 L10.6589 7.2961 C11.3309 7.2961 11.8775 7.4188 12.2989 7.6641 C12.7255 7.9041 13.0375 8.2348 13.2349 8.6562 C13.4322 9.0721 13.5309 9.5495 13.5309 10.0881 C13.5309 10.7014 13.4135 11.2188 13.1788 11.6401 C12.9495 12.0561 12.6189 12.3708 12.1869 12.5841 C11.7602 12.7921 11.2509 12.8961 10.6589 12.8962 L8.6188 12.8961 Z M9.8828 11.8001 L10.5949 11.8001 C11.0322 11.8001 11.3683 11.7281 11.6029 11.5842 C11.8429 11.4402 12.0082 11.2401 12.0989 10.9841 C12.1948 10.7281 12.2429 10.4295 12.2429 10.0882 C12.2429 9.4855 12.1042 9.0508 11.8269 8.7841 C11.5548 8.5121 11.1443 8.3762 10.5949 8.3761 L9.8829 8.3761 L9.8828 11.8001 Z M14.0467 12.8962 L14.0467 7.2961 L17.7267 7.2961 L17.7267 8.3841 L15.3107 8.3842 L15.3107 9.4001 L17.3507 9.4002 L17.3507 10.4882 L15.3107 10.4881 L15.3107 11.8082 L17.7267 11.8081 L17.7267 12.8961 L14.0467 12.8962 Z M20.8087 12.9921 C20.2274 12.9921 19.7313 12.8695 19.3207 12.6241 C18.91 12.3734 18.5953 12.0322 18.3767 11.6001 C18.1633 11.1681 18.0567 10.6721 18.0567 10.1121 C18.0567 9.5521 18.1607 9.0534 18.3687 8.6162 C18.5821 8.1735 18.8941 7.8268 19.3047 7.5761 C19.7154 7.3255 20.2167 7.2001 20.8087 7.2001 C21.502 7.2002 22.0727 7.3762 22.5207 7.7281 C22.9687 8.0748 23.2434 8.5681 23.3447 9.2081 L21.9607 9.2082 C21.9073 8.9361 21.7766 8.7255 21.5686 8.5762 C21.366 8.4268 21.1047 8.3521 20.7846 8.3522 C20.5074 8.3521 20.2594 8.4188 20.0407 8.5521 C19.822 8.6802 19.6514 8.8748 19.5287 9.1362 C19.406 9.3921 19.3447 9.7175 19.3446 10.1121 C19.3447 10.4962 19.4033 10.8188 19.5207 11.0802 C19.6434 11.3361 19.814 11.5308 20.0327 11.6642 C20.2514 11.7921 20.502 11.8562 20.7847 11.8561 C21.1047 11.8561 21.366 11.7895 21.5687 11.6561 C21.7767 11.5175 21.9073 11.3228 21.9607 11.0721 L23.3447 11.0722 C23.2433 11.6694 22.9687 12.1388 22.5207 12.4802 C22.0727 12.8215 21.502 12.9921 20.8087 12.9921 Z",
							id: `${__svgrId}-DEC`,
							style: { fill: "var(--sticker-dark,#9A6528)" }
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 34`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 9.942,
							x2: 9.942,
							y1: 15.3986,
							y2: 27.0677
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 38`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 13.9199,
							x2: 13.9198,
							y1: 15.3984,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 36`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5944,
							x2: 25.153,
							y1: 19.1321,
							y2: 19.1321
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 37`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5949,
							x2: 25.1535,
							y1: 23.0835,
							y2: 23.0835
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 35`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 17.7503,
							x2: 17.7503,
							y1: 15.3984,
							y2: 27.0675
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 39`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 21.7954,
							x2: 21.7954,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M12.8152 4.3477 L12.8151 6.1461",
							id: `${__svgrId}-Line 40`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#9A6528)" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.2456 4.3477 L19.2456 6.146",
							id: `${__svgrId}-Line 41`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#9A6528)" }
						})
					]
				})
			})
		})
	});
};
export default SvgDateDec;
